module.exports = __webpack_public_path__ + "img/cover.f25d4dd3.png";